export const EMAIL_DOMAINS = [
  'gmail.com',
  'hotmail.com',
  'aol.com',
  'yahoo.com',
];

export const BUSINESS_INFO_ROUTE = 'business-info';
export const BUY_NOW_ROUTE = 'buy-now';
export const EXISTING_USER_INVITATION = 'user-invite-exists';
export const PROFILE_ROUTE = 'profile';
export const VERIFY_ACCOUNT_ROUTE = 'verify-account';

export const SIDEBAR_REVIEWS = 'reviews';
export const SIDEBAR_PAYMENTS = 'payments';
export const SIDEBAR_WEBCHAT = 'webchat';
export const SIDEBAR_CAMPAIGNS = 'campaigns';
export const SIDEBAR_DEFAULT = 'default';

export const SIDEBAR_VARIANTS = [
  SIDEBAR_REVIEWS,
  SIDEBAR_PAYMENTS,
  SIDEBAR_WEBCHAT,
  SIDEBAR_CAMPAIGNS,
  SIDEBAR_DEFAULT,
];

export const START_TRIAL_BUTTON_LABEL = 'Start 14-day free trial';
